module.exports = __webpack_public_path__ + "img/travel09.bfbc7b89.jpg";